export const trailingSlash = /\/+$/

export const POST_MESSAGE_ORIGIN_WHITELIST = [
  // Feature branches
  /^(www\.)[a-z0-9-]+\.app\.labs\.helpdesk\.com$/,
  // Main deployments
  /^(www\.)app\.((labs\.)|(staging\.))?helpdesk\.com$/,
  // Localhost
  /^(www\.)localhost(:\d+)?$/,
]
